/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { InsuranceApi } from '../api/insurance.api';
import { switchMap, map } from 'rxjs/operators';
import { InsuranceData, Insurance } from '../../../interfaces/masters/insurance';

@Injectable()
export class InsuranceService extends InsuranceData {

  constructor(private api: InsuranceApi) {
    super();
  }


  list(url: string): Observable<Insurance[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<Insurance>{
      return this.api.getById(url);
  }

//   create(url: string, data:Payers): Observable<Payers> {
//     return this.api.add(url,data);
//   }

//   update(url: string, data:Payers): Observable<Payers> {
//     return this.api.update(url,data);
//   }

  

//   delete(url: string): Observable<boolean> {
//     return this.api.delete(url);
//   }
}
